"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundHalfEven = roundHalfEven;
exports.floorLowerHundred = floorLowerHundred;
exports.toFixedNumber = toFixedNumber;
exports.getValueByRoundingStrategy = getValueByRoundingStrategy;
function roundHalfEven(value) {
    const decCheck = value - Math.floor(value);
    return decCheck === .5
        ? (2 * Math.round(value / 2))
        : Math.round(value);
}
function floorLowerHundred(value) {
    return Math.floor(value / 100) * 100;
}
function toFixedNumber(value, digits, base = 10) {
    const pow = Math.pow(base || 10, digits);
    return Math.round(value * pow) / pow;
}
function getValueByRoundingStrategy(roundingStrategy, base, precision = 2) {
    switch (roundingStrategy) {
        case 'floorLowerHundred':
            return floorLowerHundred(base);
        case 'halfEvenClosestDollar':
            return roundHalfEven(base);
        case 'fixed':
            return toFixedNumber(base, precision, 10);
        case 'floor':
            return Math.floor(base);
        case 'ceil':
            return Math.ceil(base);
        case 'round':
            return Math.round(base);
        case 'halfEven':
        default:
            return roundHalfEven(base / 100) * 100;
    }
}
